import type { TranslationTemplate } from "../../../application.i18n";

export default {
	projectName: "Insights Live",
	authorizing: "Autoriserer...",
	"log-out": "Logg ut",
	"change-theme": "Endre tema",
	features: {
		deviations: "Avvik",
		logs: "Logger",
		activities: "Aktiviteter",
		sites: "Steder",
		realtime: "Sanntid",
		home: "Hjem",
		settings: "Innstillinger",
		preferences: "Innstillinger",
		admin: "Admin",
		metrics: "Målinger",
	},
	noAccess: {
		title: "Ingen tilgang",
		message: "Du har ikke tilgang til noen bedrift. Vennligst kontakt din administrator.",
	},
	error: {
		title: "Noe gikk galt",
		message:
			"Dette betyr at vi har et problem som er vanskelig å lokalisere. Tømme cache og lokal lagring kan hjelpe",
		navDescription: "Hvis det fortsatt ikke fungerer, kontakt vår support",
		numberText: "+47 488 52 488",
		emailText: "support.digital@scaleaq.com",
		refreshText: "Oppdater",
	},
	notFound: {
		title: "Side ikke funnet",
		message:
			"Siden du leter etter eksisterer ikke. Vennligst sjekk URL-en eller gå tilbake til hjemmesiden.",
		navDescription: "Hvis det fortsatt ikke fungerer, kontakt vår support",
		refreshText: "Oppdater",
		numberText: "+47 488 52 488",
		emailText: "support.digital@scaleaq.com",
	},
	custom: "Egendefinert",
	time: {
		"add-time": "Legg til tid",
		"select-date-range": "Velg datoperiode",
		time: "Tid",

		"last-7-days": "Siste 7 dager",
		"last-31-days": "Siste 31 dager",
		"this-month": "Denne måneden",
		"this-year": "Dette året",
		today: "I dag",
		"next-7-days": "Neste 7 dager",
		"next-31-days": "Neste 31 dager",
		timeframe: "Tidsramme",
		"6hours": "6 timer",
		"12hours": "12 timer",
		"24hours": "24 timer",
		"7days": "7 dager",
	},
	dataType: {
		water_oxygen_percentage: "Oksygen",
		water_oxygen_umol: "Oksygen",
		water_oxygen_mg_l: "Oksygen",
		water_temperature: "Vann temperatur",
		water_salinity: "Saltholdighet",
		sensor_depth: "Dybde",
		Appetite: "Appetitt",
		Biomass: "Biomasse",
		Dose: "Dose",
		FeedAmount: "Fôrmengde",
		FishWeight: "Fiskvekt",
		HandFeedWeight: "Håndfôrvekt",
		Intensity: "Intensitet",
		Loadcell: "Lastcelle",
		ManualAmount: "Manuell mengde",
		Mean: "Gjennomsnitt",
		PelletCount: "Pellet antall",
		PelletFishMinute: "Pellet per fisk per minutt",
		Planned: "Planlagt",
		Recommended: "Anbefalt",
		SFR: "SFR",
		SGR: "SGR",
		StandardAppetite: "Standard appetitt",
		Target: "Mål",
		TodayAppetite: "Dagens appetitt",
		TotalFeedWeight: "Total fôrvekt",
		avgWeight: "Gjennomsnittsvekt",
		blowerSpeed: "Blåserhastighet",
		compass: "Kompass",
		conductivity: "Konduktivitet",
		fcr: "FCR",
		feedStoreAmount: "Fôrlager mengde",
		humidity: "Fuktighet",
		latitude: "Breddegrad",
		longitude: "Lengdegrad",
		pellet_count: "Pellet antall",
		pressure: "Trykk",
		pressurePipe: "Trykkrør",
		recommendedFeedWeight: "Anbefalt fôrvekt",
		runtime: "Kjøretid",
		sal_conductivity: "Saltholdighet konduktivitet",
		sal_density: "Saltholdighet tetthet",
		sal_sound_speed: "Saltholdighet lydhastighet",
		sal_temp: "Saltholdighet temperatur",
		saturation: "Metning",
		sc_abs_tilt: "Havstrøm absolutt helning",
		sc_heading: "Havstrøm retning",
		sc_max_tilt: "Havstrøm maks helning",
		sc_sp_standard: "Havstrøm hastighet standard",
		sc_std_tilt: "Havstrøm standard helning",
		sc_strength: "Havstrøm styrke",
		sc_tilt_x: "Havstrøm helning X",
		sc_tilt_y: "Havstrøm helning Y",
		sea_current_absolute_speed: "Havstrøm hastighet",
		sea_current_direction: "Havstrøm retning",
		sea_current_east: "Havstrøm øst",
		sea_current_north: "Havstrøm nord",
		sgr: "SGR",
		smartSpreaderCycleTime: "Smart spreder syklustid",
		smartSpreaderCyclicMax: "Smart spreder syklisk maks",
		smartSpreaderCyclicMin: "Smart spreder syklisk min",
		smartSpreaderManualSpeed: "Smart spreder manuell hastighet",
		targetRecommended: "Mål anbefalt",
		temperatureFeedingLine: "Temperatur fôrlinje",
		wind_direction: "Vindretning",
		wind_speed: "Vindhastighet",
	},
	buttons: {
		back: "Tilbake",
	},
} satisfies TranslationTemplate["COMMON"];
